import React from 'react';
import styled from '@emotion/styled';
import { Title } from 'app/components/Typography/Title';
import { Col, Row } from 'antd';
import CardFile from 'app/components/Card/File';

const Container = styled.div`
  > h5 {
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0.005em;
    color: #232b3a;
  }
`;
const StyledMediaItem = styled.div`
  margin: 8px;
  width: 65px;
  height: 65px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const StyledOtherMediaItem = styled.div`
  margin: 8px;
  height: 65px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  .ant-card-body {
    padding: 16px;
  }
  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
type Props = {
  title?: React.ReactNode;
  media: any[];
};
const ReferenceMedia: React.FC<Props> = ({ title, media }) => {
  const isVideo = (mineType: string) => {
    return mineType.includes('video');
  };
  const renderFile = (file: any) => {
    if (file?.mineType.includes('video') || file?.mineType.includes('image')) {
      return (
        <Col key={file.id}>
          <StyledMediaItem
            onClick={() => {
              window.open(file.url, '_blank');
            }}
          >
            {isVideo(file.mineType || '') ? (
              <video src={file.url}></video>
            ) : (
              <img src={file.url}></img>
            )}
          </StyledMediaItem>
        </Col>
      );
    }
    return (
      <Col key={file.id}>
        <StyledOtherMediaItem
          onClick={() => {
            window.open(file.url, '_blank');
          }}
        >
          <CardFile file={file}></CardFile>;
        </StyledOtherMediaItem>
      </Col>
    );
  };
  return (
    <Container>
      <Title level={5}>{title || 'Reference Media:'}</Title>
      <Row>
        {(media || []).map((file: any) => {
          if (!file) return null;
          return renderFile(file);
        })}
      </Row>
    </Container>
  );
};

export default ReferenceMedia;
